import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import {
  ToolsService,
  SbuDto,
  TestMetricsResultDto,
  MetricsGroupDto
} from '../../services/tools.service';

@Component({
  selector: 'app-metrics',
  standalone: true,
  imports: [CommonModule, FormsModule, MatDialogModule],
  templateUrl: './metrics.component.html',
  styleUrls: ['./metrics.component.css']
})
export class MetricsComponent implements OnInit {

  // Filter controls
  fromDate: string = '';
  toDate: string = '';
  sbuCode: string = '';

  sbus: SbuDto[] = [];
  isLoadingSbus = false;

  // Results
  result: TestMetricsResultDto | null = null;
  isLoading = false;
  errorMessage: string | null = null;

  constructor(private toolsService: ToolsService, public dialogRef: MatDialogRef<MetricsComponent>) {}


  ngOnInit(): void {
    // Default: last 1 year — mirrors WPF TestMetricsRequest constructor
    const today = new Date();
    this.toDate = this.toIsoDate(today);
    const from = new Date(today);
    from.setFullYear(from.getFullYear() - 1);
    this.fromDate = this.toIsoDate(from);

    this.loadSbus();
  }

  private toIsoDate(d: Date): string {
    return d.toISOString().substring(0, 10);
  }

  private loadSbus(): void {
    this.isLoadingSbus = true;
    this.toolsService.getSbus().subscribe({
      next: (data) => {
        this.sbus = data;
        this.isLoadingSbus = false;
        this.refresh(); // auto-load on open, mirrors WPF OnRefresh() in constructor
      },
      error: () => { this.isLoadingSbus = false; }
    });
  }

  get isValid(): boolean {
    return !!this.fromDate && !!this.toDate && this.toDate >= this.fromDate;
  }

  refresh(): void {
    if (!this.isValid) return;
    this.errorMessage = null;
    this.isLoading = true;
    this.result = null;

    this.toolsService.getTestMetrics(
      this.fromDate,
      this.toDate,
      this.sbuCode || undefined
    ).subscribe({
      next: (data) => {
        this.result = data;
        this.isLoading = false;
      },
      error: (err) => {
        this.errorMessage = err?.error?.detail ?? 'Failed to load metrics.';
        this.isLoading = false;
      }
    });
  }

  // Track-by for *ngFor performance
  trackByName(_: number, item: MetricsGroupDto): string {
    return item.name;
  }
}
